/**
 * 🆕 [v9 — 2026-06-12] Bus global pour le tooltip Gantt actif.
 *
 * CONTEXTE — Bug #3 P2 Calendrier de production (signalé par Eliot) :
 *   Chaque instance de <GanttGridRow> avait son propre useState
 *   `hoveredBonId` → 2 chefs sur 2 lanes différentes pouvaient afficher
 *   2 tooltips simultanément. Aussi : pas de délai d'apparition → tooltip
 *   se déclenche au moindre survol involontaire.
 *
 * RÔLE — Singleton module-level qui maintient l'ID du BT/SC dont le tooltip
 * est actuellement affiché. Quand un nouveau tooltip s'ouvre, tous les
 * abonnés reçoivent la notification et ferment leur tooltip local.
 *
 * USAGE :
 *   const [hoveredId, setHoveredId] = useState(null);
 *   useEffect(() => subscribeTooltipBus((activeId) => {
 *     if (activeId !== hoveredId && hoveredId !== null) setHoveredId(null);
 *   }), [hoveredId]);
 *   // À l'ouverture : setActiveTooltipId(bonId); setHoveredId(bonId);
 *   // À la fermeture : setActiveTooltipId(null); setHoveredId(null);
 */
let activeId = null;
const listeners = new Set();

export function setActiveTooltipId(id) {
  if (activeId === id) return;
  activeId = id;
  listeners.forEach(fn => {
    try { fn(id); } catch { /* ignore listener errors */ }
  });
}

export function getActiveTooltipId() {
  return activeId;
}

export function subscribeTooltipBus(fn) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
